import React, { Component } from 'react'
import { Grid } from 'react-bootstrap'
import { Link } from 'react-router'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import { OptionsHOC } from '../../hocs'
import styled, { withTheme } from 'styled-components'

const Wrapper = styled.div`
  h3 {
    margin-top: 20px;
    color: var(--clr-accent-to-black);
    text-decoration: underline;
    display: inline-block;
  }
`
class GettingStarted extends Component {
  render() {
    const { language, query, currentPhone, createUserEvent } = this.props
    const translated = messages[language]

    return (
      <Wrapper>
        <Grid id="start-link">
          <Link
            to={{ pathname: '/getstarted', query: query }}
            onClick={() =>
              createUserEvent({
                category: 'navigation',
                data: { link_to: '/getstarted', source: 'HeaderGettingStarted' }
              })
            }
          >
            <h3>
              {translated['start']} {currentPhone && currentPhone.manufacturer}{' '}
              {currentPhone && currentPhone.name}
            </h3>
          </Link>
        </Grid>
      </Wrapper>
    )
  }
}

export default LanguageProvider(withTheme(OptionsHOC(GettingStarted)))



// WEBPACK FOOTER //
// ./src/components/GettingStartedNavLink/GettingStartedNavLink.js